const Footer = () => {
    return ( <> <p className="footer">Made with ❤️ by Shahbaz and Nabia</p> </> );
}
 
export default Footer;